// LiveStreamChatHandler.js
import { connect } from 'react-redux';

import LiveStreamChatHandler from '../component/LiveStreamChatHandler.jsx';
import { clearLiveStreamChatQueue } from '../action/liveStreamChatActions.js';

const mapDispatchToProps = (dispatch, { streamId }) => {
  return {
    clearLiveStreamChatQueue: () =>
      dispatch(clearLiveStreamChatQueue({ streamId })),
  };
};

export default connect(null, mapDispatchToProps)(LiveStreamChatHandler);
